import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BackOfficeUtilities  {
    _originalTypeClassName = "zERP.BO.BackOfficeUtilities";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackOfficeUtilities.translate = translateService;
}
this.BackOfficeUtilitiesKey = null;
this._key = this.BackOfficeUtilitiesKey = 0; 
}

static translate: TranslateService;
_key: any;
private _BackOfficeUtilitiesKey:any;
get BackOfficeUtilitiesKey(): any {
    return this._BackOfficeUtilitiesKey;
  }
set BackOfficeUtilitiesKey(value: any) {
    this._BackOfficeUtilitiesKey = value;
    this._key = value;
  }

static AddOrUpdateTax(execution: any,invoice: any,currentTax: any,amount: any,externalDocumentId: any,externalLineId: any): any{let syncInfo = new Domain.ExternalSystemSyncedLineInfo();
syncInfo.SyncedOn = execution?.ExecutedOn;
syncInfo.DocumentId = externalDocumentId;
syncInfo.DocumentLineId = externalLineId;
syncInfo.Amount = amount;
if (invoice?.TaxesTotals?.linq?.any((l) => l?.Tax == currentTax)) {let taxToUpdate = invoice?.TaxesTotals?.linq?.where((l) => l?.Tax == currentTax)?.firstOrDefault(null);taxToUpdate.TaxAmount = Joove.Common.safeNumber(taxToUpdate?.TaxAmount) + Joove.Common.safeNumber(amount);taxToUpdate?.ExternalSystemInfo?.add(syncInfo);}else {let type = new Domain.TaxTotalsType();Domain.TaxTotalsType.setTax(type, currentTax);type.TaxAmount = amount;type.TaxTypeEnum = currentTax?.Type;type?.ExternalSystemInfo?.add(syncInfo);invoice?.TaxesTotals?.add(type);}
}
static CanExecuteSchedule(config: any): any{console.info(CLMS.Framework.String.Format("Can Execute Schedule {0}", config?.DocumentType));
let nextExecutionTime = (Domain.DateHelper.IsDateNull(config?.LastSyncDate) ? (moment(moment().toDate()).add(-10, "d")).toDate() : config?.LastSyncDate);
nextExecutionTime = nextExecutionTime;
let intervalInMinutes = (CLMS.Framework.Number.GreaterThan(() => config.SchedulingMinutesInterval, () => 0) ? config?.SchedulingMinutesInterval : (Joove.Common.safeNumber(24) * Joove.Common.safeNumber(60)));
console.info(" -> interval: " + Joove.Common.safeNumber(intervalInMinutes));
let now = moment(moment().toDate()).utc().toDate();
nextExecutionTime = (moment(nextExecutionTime).add(intervalInMinutes, "m")).toDate();
console.info(" -> nextExecutionTime: " + nextExecutionTime + " now: " + now);
if ((new Date(nextExecutionTime).getTime()) > (new Date(now).getTime())) {console.info(" -> not time yet....: " + now);return false;}
if (CLMS.Framework.Number.GreaterThan(() => config.SchedulingHourFrom, () => 0) && CLMS.Framework.Number.GreaterThanOrEqual(() => Domain.DateHelper.GreekHourToUTC(config.SchedulingHourFrom), () => moment(nextExecutionTime).hours())) {console.info(" -> not appropriate hour from: " + Joove.Common.safeNumber(config?.SchedulingHourFrom));return false;}
if (CLMS.Framework.Number.GreaterThan(() => config.SchedulingHourTo, () => 0) && CLMS.Framework.Number.LessThan(() => Domain.DateHelper.GreekHourToUTC(config.SchedulingHourTo), () => moment(nextExecutionTime).hours())) {console.info(" -> not appropriate hour to: " + Joove.Common.safeNumber(config?.SchedulingHourFrom));return false;}
return true;
}
static GetHoursOfDay(): any{let data = [];
for (var i = 0; CLMS.Framework.Number.LessThan(() => i, () => 23); i = Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1)) {
data?.add(i);}

return data;
}
static GetTransactionEntityDescription(entity: any): any{let name = entity?.FullName;
if (!(CLMS.Framework.String.IsNullOrEmpty((entity?.FatherName ?? '').trim()))) {name = name + " του " + entity?.FatherName;}
return name;
}
static UpdateInvoiceSummary(invoice: any): any{invoice.InvoiceSummary.TotalGrossValue = Joove.Common.safeNumber(invoice?.InvoiceSummary?.TotalNetValue) + Joove.Common.safeNumber(invoice?.InvoiceSummary?.TotalVatAmount) + Joove.Common.safeNumber(invoice?.InvoiceSummary?.TotalWithheldAmount) + Joove.Common.safeNumber(invoice?.InvoiceSummary?.TotalDeductionsAmount) + Joove.Common.safeNumber(invoice?.InvoiceSummary?.TotalFeesAmount) + Joove.Common.safeNumber(invoice?.InvoiceSummary?.TotalOtherTaxesAmount) + Joove.Common.safeNumber(invoice?.InvoiceSummary?.TotalStampDutyAmount);
invoice.InvoiceSummary.TotalGrossValueWithDeductions = Joove.Common.safeNumber(invoice?.InvoiceSummary?.TotalNetValue) + Joove.Common.safeNumber(invoice?.InvoiceSummary?.TotalVatAmount);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BackOfficeUtilitiesKey == null || $this.BackOfficeUtilitiesKey == 0;
            }


}